import { useTranslations } from 'next-intl';
import { PopoverMenu } from '..';
import classNames from 'classnames';
import DropdownFilterFlatOptions from './DropdownFilterFlatOptions';
import DropdownFilterTreeOptions from './DropdownFilterTreeOptions';

export type DropdownFilterOptionType = {
  label: string;
  value: string;
  count: number;
  disabled: boolean;
  options?: DropdownFilterOptionType[];
};

export interface IDropdownFilter {
  value: string[];
  name: string;
  disabled: boolean;
  options: DropdownFilterOptionType[];
  className?: string;
  clearBtnLabel?: string;
  onChange?: (value: string) => void;
  onClear?: () => void;
}

const DropdownFilter = ({
  value,
  name,
  disabled,
  options,
  onChange,
  onClear,
  className,
  clearBtnLabel,
}: IDropdownFilter) => {
  const t = useTranslations();

  // Check if options have nested tree structure
  const hasTreeStructure = options.some((opt) => opt.options && opt.options.length > 0);

  return (
    <PopoverMenu
      title={name + '' + (value?.length > 0 ? ` (${value.length})` : '')}
      className={classNames(
        '[&_.main-button]:h-10 [&_.main-button]:rounded-4xl [&_.main-button]:border [&_.main-button]:border-black/10 [&_.main-button]:px-4 [&_.main-button]:whitespace-nowrap [&.open_.main-button]:bg-white',
        '[&_.content]:rounded-3xl [&_.content]:border [&_.content]:border-black/10 [&_.content]:shadow-lg',
        'w-full md:w-auto [&_.main-button]:justify-center',
        className,
      )}
      titleClass="text-sm font-medium"
      offset={10}
      placement="bottom-start"
      contentWrapperClassName="overflow-hidden"
      disabled={disabled}
    >
      <div className={classNames('flex grow flex-col gap-4 overflow-y-auto p-4')}>
        {hasTreeStructure ? (
          <DropdownFilterTreeOptions options={options} value={value} onChange={onChange} />
        ) : (
          <DropdownFilterFlatOptions options={options} value={value} onChange={onChange} />
        )}
      </div>

      <div className="flex justify-center border-t border-gray-300">
        <button className="btn" onClick={onClear}>
          {clearBtnLabel || t('general.$clear')}
        </button>
      </div>
    </PopoverMenu>
  );
};

export default DropdownFilter;
